import * as React from "react";
import { validEmail } from "../../Variables";
import { Modal } from "react-bootstrap";
import { useContextStateManagement } from "../../context/ContextApi";
import "../Auth/Auth.css";
import "./ManageOrg.css";


const { useState } = React;

export const AddUsersToOrg = () => {
  const [emailMessage, setEmailMessage] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const [nameMessage, setNameMessage] = useState("");
  const [professionMessage, setProfessionMessage] = useState("");
  const [codeMessage, setCodeMessage] = useState("");
  const [practiceCode, setPracticeCode] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [practiceInfo, setPracticeInfo] = useState({ name: "", address: "" });
  const { setSideBarLinkActive, userType, token, usersPostRequest } =
    useContextStateManagement();

  if (userType !== "admin") {
    return null;
  }


  const handleConfirm = () => {
    setShowModal(false);
  };

  const handleCancel = () => {
    console.log("Cancelled");
    setShowModal(false);
  };

  const handleBind = (e) => {
    e.target.disabled = true;
    let practiceCode = document.getElementById("practiceCode");
    usersPostRequest(token, "/api/checkPracticeCode", {
      practiceCode: practiceCode.value,
    })
      .then((data) => {
        if (data && data.practiceName && data.practiceAddress) {
          setPracticeInfo({
            name: data.practiceName,
            address: data.practiceAddress,
          });
          setPracticeCode(practiceCode.value);
          setShowModal(true);
          return;
        }

        alert(typeof data === "string" ? data : "Server is not responding");
        practiceCode.value = "";
        setPracticeCode("");
      })
      .finally(() => {
        e.target.disabled = false;
      });
  };

  const handleRegister = (e) => {
    e.target.disabled = true;
    let email = document.getElementById("userEmail");
    let pass = document.getElementById("userPassword");
    let name = document.getElementById("newUserName");
    let profession = document.getElementById("userProfession");
    let code = document.getElementById("practiceCode");
    let isFieldEmpty = false;
    let user = {
      PracticeCode: practiceCode,
      UserName: name.value,
      UserProfession: profession.value,
      UserEmail: email.value,
      UserPassword: pass.value,
    };

    if (user.UserName === "") {
      name.classList.add("empty");
      isFieldEmpty = true;
      setNameMessage("Enter username");
    }

    if (user.UserProfession === "") {
      profession.classList.add("empty");
      isFieldEmpty = true;
      setProfessionMessage("Enter user profession");
    }

    if (user.UserEmail === "") {
      email.classList.add("empty");
      isFieldEmpty = true;
      setEmailMessage("Enter your email");
    } else if (
      user.UserEmail !== "" &&
      validEmail.test(user.UserEmail) === false
    ) {
      email.classList.add("empty");
      isFieldEmpty = true;
      setEmailMessage("Enter a valid email");
    }

    if (user.UserPassword === "") {
      pass.classList.add("empty");
      isFieldEmpty = true;
      setPasswordMessage("Enter password");
    } else if (user.UserPassword.length < 6) {
      isFieldEmpty = true;
      setPasswordMessage("Enter 6 digits / characters or more");
    }

    if (code.value === "") {
      code.classList.add("empty");
      isFieldEmpty = true;
      setCodeMessage("Enter organization code");
    } else if (code.value !== practiceCode) {
      code.classList.add("empty");
      isFieldEmpty = true;
      setCodeMessage("Please link the organization code");
    }

    if (isFieldEmpty === true) {
      e.target.disabled = false;
      return;
    }

    usersPostRequest(token, "/api/admin/registerUser", user)
      .then((response) => {
        if (response && response.register) {
          code.value = "";
          setPracticeCode("");
          name.value = "";
          profession.value = "";
          email.value = "";
          pass.value = "";

          alert("User registered successfully");
          setSideBarLinkActive("careConsole");
        } else {
          alert(
            typeof response === "string"
              ? response
              : "Server is not responding, Check your connection string",
          );
        }
      })
      .finally(() => {
        e.target.disabled = false;
      });
  };

  const resetErrorFieldStyle = (e) => {
    if (e.target.classList.contains("empty")) {
      e.target.classList.remove("empty");
    }

    if (e.target.id === "newUserName") {
      setNameMessage("");
    } else if (e.target.id === "userProfession") {
      setProfessionMessage("");
    } else if (e.target.id === "userEmail") {
      setEmailMessage("");
    } else if (e.target.id === "userPassword") {
      setPasswordMessage("");
    } else if (e.target.id === "practiceCode") {
      setCodeMessage("");
    }
  };

  return (
    <>
      <div className="add-user-shell">
        <div className="add-user-card">
          <div className="add-user-header">
            <div>
              <h3 className="add-user-title">Add User</h3>
              <p className="add-user-copy">
                Create a user and link them to an organization in one place.
              </p>
            </div>
          </div>

          <div className="add-user-section">
            <div className="add-user-section__header">
              <span className="add-user-section__eyebrow">Step 1</span>
              <h4>Link Organization</h4>
            </div>

            <div className="add-user-field add-user-field--full">
              <label className="add-user-label" htmlFor="practiceCode">
                Organization Code
              </label>
              <div className="add-user-code-row">
                <div className="add-user-code-wrap">
                  <input
                    type="text"
                    id="practiceCode"
                    className="add-user-input"
                    placeholder="Enter organization code"
                    onFocus={resetErrorFieldStyle}
                  />
                </div>
                <button type="button" className="bind-btn" onClick={handleBind}>
                  Link
                </button>
              </div>
              <small className="add-user-error">{codeMessage}</small>
            </div>
          </div>

          <div className="add-user-section">
            <div className="add-user-section__header">
              <span className="add-user-section__eyebrow">Step 2</span>
              <h4>User Details</h4>
            </div>

            <div className="add-user-grid">
              <div className="add-user-field">
                <label className="add-user-label" htmlFor="newUserName">
                  Username
                </label>
                <input
                  type="text"
                  id="newUserName"
                  className="add-user-input"
                  placeholder="Enter user name"
                  onFocus={resetErrorFieldStyle}
                />
                <small className="add-user-error">{nameMessage}</small>
              </div>

              <div className="add-user-field">
                <label className="add-user-label" htmlFor="userProfession">
                  User Profession
                </label>
                <input
                  type="text"
                  id="userProfession"
                  className="add-user-input"
                  placeholder="Enter user profession"
                  onFocus={resetErrorFieldStyle}
                />
                <small className="add-user-error">{professionMessage}</small>
              </div>

              <div className="add-user-field">
                <label className="add-user-label" htmlFor="userEmail">
                  User Email
                </label>
                <input
                  type="email"
                  id="userEmail"
                  className="add-user-input"
                  placeholder="Enter user email"
                  onFocus={resetErrorFieldStyle}
                />
                <small className="add-user-error">{emailMessage}</small>
              </div>

              <div className="add-user-field">
                <label className="add-user-label" htmlFor="userPassword">
                  User Password
                </label>
                <input
                  type="password"
                  id="userPassword"
                  className="add-user-input"
                  placeholder="Enter password"
                  onFocus={resetErrorFieldStyle}
                />
                <small className="add-user-error">{passwordMessage}</small>
              </div>
            </div>
          </div>

          <div className="add-user-actions">
            <button type="button" className="simple-btn" onClick={handleRegister}>
              Add User
            </button>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={handleCancel}
        centered
        className="popup add-user-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Organization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center mb-3">
            <h5>Organization Name:</h5>
            <p className="text-muted">{practiceInfo.name}</p>
            <h5>Organization Address:</h5>
            <p className="text-muted">{practiceInfo.address}</p>
          </div>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <button type="button" className="simple-btn" onClick={handleConfirm}>
            Confirm
          </button>
          <button type="button" className="simple-btn" onClick={handleCancel}>
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

